module.exports = __webpack_public_path__ + "static/img/index-selected.ba9c172a.svg";